import React from "react";
import './../../assets/css/pages/esg-council-content.css';

// A list of text points the admin can edit, reorder (arrows), remove (cross) and add to. Used for the ESG council guidelines and
// learning points. `onChange` receives the whole new list.
function PointListEditor(props) {
    const {items, onChange, addLabel, max = 30, maxLength = 1000} = props;

    const change = (index, value) => onChange(items.map((v, i) => (i === index ? value : v)));
    const remove = (index) => onChange(items.filter((_, i) => i !== index));
    const add = () => items.length < max && onChange([...items, ""]);
    const move = (index, step) => {
        const target = index + step;
        if (target < 0 || target >= items.length) return;
        const next = [...items];
        [next[index], next[target]] = [next[target], next[index]];
        onChange(next);
    };

    return (
        <>
            {items.map((item, i) => (
                <div key={i} className="d-flex gap-2 align-items-start mb-2">
                    <span className="esg-content-question-no">{i + 1}.</span>
                    <textarea
                        className="form-control"
                        rows="2"
                        maxLength={maxLength}
                        value={item}
                        onChange={(e) => change(i, e.target.value)}
                    />
                    <div className="btn-group-vertical">
                        <button type="button" className="btn btn-sm btn-outline-secondary" disabled={i === 0} onClick={() => move(i, -1)} title="Move up">↑</button>
                        <button type="button" className="btn btn-sm btn-outline-secondary" disabled={i === items.length - 1} onClick={() => move(i, 1)} title="Move down">↓</button>
                    </div>
                    <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => remove(i)} title="Remove">✕</button>
                </div>
            ))}
            <button type="button" className="btn btn-sm btn-outline-info" disabled={items.length >= max} onClick={add}>+ {addLabel}</button>
        </>
    );
}

export default PointListEditor;
